import { Typography, FormControlLabel, Switch } from "@mui/material";
import { AclTypes } from "../../../Core/Api/Types/acl-types";
import { DbOrderBasketItemInfos } from "../../../Core/Api/Types/db-order-basket-item-infos";
import { Licences } from "../../../Core/Api/Types/licences";
import { TranskodeWatermarkVendor } from "../../../Core/Api/Types/transkode-watermark-vendor";
import { ProductField, UpdateItemProductRootOnBasket } from "../../../Redux/Reducers/redux-slice-basket";
import { UserHasLicence, UserHasAcl } from "../../../Utils/helpers";
import FormSection from "../../Forms/FormSection/form-section";
import ConfigFormIcon from "../ConfigFormIcon";
import { useAppDispatch } from "../../../Redux/redux-store";
import { ObjectLayer } from "../../../Core/Api/Types/object-layer";
import { ObjectType } from "../../../Core/Api/Types/object-type";
import { useTranslation } from "react-i18next";

interface ConfigCommonSectionFormNexguardWatermarkProps {
  item: DbOrderBasketItemInfos;
}

const ConfigCommonSectionFormNexguardWatermark = (props: ConfigCommonSectionFormNexguardWatermarkProps) => {
  const { t } = useTranslation();
  const { item } = props;

  const dispatch = useAppDispatch();

  // Update product root base object into redux
  const handleUpdateProductRoot = (field: ProductField, value: any) => {
    dispatch(UpdateItemProductRootOnBasket({ itemId: item.id, field: field, value: value }));
  };

  return (
    <FormSection
      icon={<ConfigFormIcon icon="watermark" />}
      title={t("common:watermarking")}
      status={!item.selectedProduct?.watermarkSecurity ? "todo" : "complete"}
      statusText={
        !item.selectedProduct?.watermarkSecurity
          ? t("form:statusText.configurationIsOptional")
          : t("form:statusText.applyNexguardWatermark")
      }
      sx={{
        display:
          !UserHasLicence(Licences.WatermarkNexguardCivolution) ||
          !UserHasAcl(AclTypes.aclOrderWatermarcking) ||
          (item.objectLayer === ObjectLayer.Asset && item.assetInfos?.type !== ObjectType.Video)
            ? "none"
            : "",
      }}
    >
      <Typography color="text.tier">
        <FormControlLabel
          sx={{ mt: 0, ml: 0 }}
          control={
            <Switch
              size="small"
              checked={item.selectedProduct?.watermarkSecurity === TranskodeWatermarkVendor.NexguardCivolution}
              onChange={() => handleUpdateProductRoot(ProductField.WatermarkProcessingVendor, null)}
            />
          }
          label={t("field:label.watermarkSwitch")}
        />
      </Typography>
    </FormSection>
  );
};

export default ConfigCommonSectionFormNexguardWatermark;
